export default __webpack_public_path__ + "static/media/Langs.a0eba433.svg";